import React from 'react';

import ManagedInput from 'components/form/managed_input';

import type { Attribute } from './types';

interface Props {
  attribute: Attribute;
  sharedAttributes: string[];
  onChange: (sharedAttributes: string[]) => void;
}

export function ShareableAttributeInput({ attribute, sharedAttributes, onChange }: Props) {
  const hasAttribute = sharedAttributes.includes(attribute.key);

  function toggleAttribute() {
    if (hasAttribute) {
      onChange(sharedAttributes.filter(key => key !== attribute.key));
    } else {
      onChange([...sharedAttributes, attribute.key]);
    }
  }

  return (
    <ManagedInput
      checked={hasAttribute}
      label={attribute.label}
      type="checkbox"
      onChange={toggleAttribute}
    />
  );
}
